import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { Button } from "reactstrap";
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';

import SystemAnnouncementList from "./SystemAnnouncementList";
import AddAnnouncementModal from "./AddAnnouncementModal";
import DeleteAnnouncementConfirmationModal from "../../CommonComponents/NegativeActionConfirmationModal/NegativeActionConfirmationModal";
import Spinner from "../../Spinner/Spinner";

import { systemAnnouncementAction } from "CONFIG/ActionFactory";

import { getMessage } from "CONFIG/i18n";

class SystemAnnouncementContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      announcements: [],
      showAddAnnouncementModal: false,
      showDeleteAnnouncementConfirmationModal: false,
      announcementData: null,
      deleteAnnouncementId: null,
      showAnnouncementList: false,
      spinnerVisibility: false
    }
  }

  componentDidMount() {
    this.showSpinner();
    this.getAllAnnouncements();
  }

  getAllAnnouncements = () => {
    systemAnnouncementAction.getAllAnnouncementsAction().then(
      (response) => {
        this.setState({
          announcements: response.data,
          showAnnouncementList: true
        })
        this.hideSpinner();
      },
      (error) => {
        console.error(error);
        this.hideSpinner();
        toastr.error(getMessage(error.code))
      }
    )
  }

  addAnnouncement = (announcementData, callback) => {
    systemAnnouncementAction.addAnnouncementAction(announcementData).then(
      (response) => {
        this.showAddAnnouncementModal(false, null);
        this.getAllAnnouncements();
        toastr.success(getMessage("ADD_ANNOUNCEMENT_SUCCESS"))
        callback();
      },
      (error) => {
        callback(error);
      }
    )
  }

  editAnnouncement = (announcementData, callback) => {
    systemAnnouncementAction.updateAnnouncementAction(announcementData).then(
      (response) => {
        this.showAddAnnouncementModal(false, null);
        this.getAllAnnouncements();
        toastr.success(getMessage("EDIT_ANNOUNCEMENT_SUCCESS"))
        callback();
      },
      (error) => {
        callback(error);
      }
    )
  }

  deleteAnnouncement = () => {
    systemAnnouncementAction.deleteAnnouncementAction(this.state.deleteAnnouncementId).then(
      response => {
        this.getAllAnnouncements();
        this.showDeleteAnnouncementConfirmationModal(false, null);
        toastr.success(getMessage("DELETE_ANNOUNCEMENT_SUCCESS"));
      },
      error => {
        console.error(error);
        toastr.error(getMessage(error.code))
        this.showDeleteAnnouncementConfirmationModal(false, null)
      }
    )
  }

  showAddAnnouncementModal = (showModal, announcementData=null) => {
    this.setState({
      showAddAnnouncementModal: showModal,
      announcementData: announcementData
    })
  }

  showDeleteAnnouncementConfirmationModal = (showModal, announcementId=null) => {
    this.setState({
      showDeleteAnnouncementConfirmationModal: showModal,
      deleteAnnouncementId: announcementId
    })
  }

  showSpinner = () => {
    this.setState({
      spinnerVisibility: true
    });
  };

  hideSpinner = () => {
    this.setState({
      spinnerVisibility: false
    });
  };
  
  render() {
    return (
      <div className="displayFlex flexDirectionColumn alignItemsCenter">
        <Spinner showSpinner={this.state.spinnerVisibility} />
        {this.state.showAddAnnouncementModal &&
          <AddAnnouncementModal
            show={this.state.showAddAnnouncementModal}
            showAddAnnouncementModal={this.showAddAnnouncementModal}
            updateAnnotation={this.state.announcementData
              ? this.editAnnouncement
              : this.addAnnouncement}
            announcementData={this.state.announcementData}
            saveBtnText={this.state.announcementData
              ? getMessage("SAVE")
              : getMessage("ADD")}
            headerText={this.state.announcementData
              ? getMessage("EDIT_ANNOUNCEMENT")
              : getMessage("ADD_ANNOUNCEMENT")}
          />
        }

        {this.state.showDeleteAnnouncementConfirmationModal && 
          <DeleteAnnouncementConfirmationModal 
            handleNoClick={() => 
              this.showDeleteAnnouncementConfirmationModal(false, null)
            }
            handleYesClick={this.deleteAnnouncement}
            confirmationText={getMessage('DELETE_ANNOUNCEMENT_CONFIRMATION_TEXT')}
          />
        }

        {this.state.showAnnouncementList &&
          <React.Fragment>
            <SystemAnnouncementList
              announcements={this.state.announcements}
              showAddAnnouncementModal={this.showAddAnnouncementModal}
              showDeleteAnnouncementConfirmationModal={this.showDeleteAnnouncementConfirmationModal}
              editAnnouncement={this.editAnnouncement}
              language={this.props.language}
            />
            <Button
              className="customBtn my-3"
              onClick={() => 
                this.showAddAnnouncementModal(true)
              }>
              {getMessage("ADD_ANNOUNCEMENT")}
            </Button>
          </React.Fragment>
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {};
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
  }, dispatch)
}

export default connect(
  mapStateToProps, 
  mapDispatchToProps)
(SystemAnnouncementContainer);